export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6599.69a50d05.jpg";